import React from 'react';
import PropTypes from 'prop-types';

/**
 * @deprecated Use { Switch } from `@companycam/slab-web` instead
 *
 * https://slab-web.cocam.co/?path=/docs/switch--docs
 */

const Toggle = ({
  accessibilityLabel,
  id,
  name,
  label,
  checked,
  onChange,
  tooltip,
  lightSwitchTooltip,
  labelOff,
  labelOn,
  style,
  size,
  dark,
  ...props
}) => {
  return (
    <div className={`tg-list ${size ? `tg-list--${size}` : ''}`} style={style}>
      <div className="tg-list-title-wrap">
        {label ? <span className="tg-list-title">{label}</span> : null}
        {tooltip && (
          <span className="hint--right hint--large" aria-label={tooltip}>
            <i className="mdi mdi-help-circle" />
          </span>
        )}
      </div>
      <div
        className={
          lightSwitchTooltip
            ? 'tg-list-item hint hint--top-left'
            : 'tg-list-item'
        }
        aria-label={lightSwitchTooltip || null}
      >
        {/* eslint-disable react/jsx-props-no-spreading */}
        <input
          className={`tgl ${dark ? 'tgl-dark' : 'tgl-light'}`}
          id={id || name}
          name={name}
          onChange={onChange}
          type="checkbox"
          checked={checked}
          {...props}
        />
        <label
          className="tgl-btn"
          htmlFor={name}
          data-off-label={labelOff}
          data-on-label={labelOn}
        >
          <span className="sr-only">{accessibilityLabel}</span>
        </label>
      </div>
    </div>
  );
};

Toggle.propTypes = {
  accessibilityLabel: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  tooltip: PropTypes.string,
  labelOff: PropTypes.string,
  labelOn: PropTypes.string,
  style: PropTypes.object,
  lightSwitchTooltip: PropTypes.string,
  size: PropTypes.string,
  dark: PropTypes.bool,
};

export default Toggle;
